import React, { useEffect, useState } from "react";
import {
  Table,
  TableSum,
  TableHeader,
  TableRow,
  TitleCell,
} from "./ADDisplayInfo.style";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import {
  getADDisplayInfoList,
  getADDisplayInfoSUMList,
} from "../../api/project";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

function ADDisplayInfo() {
  const [loading, setLoading] = useState(false);
  const [infoList, setInfoList] = useState([]);
  const [infoSUMList, setSUMInfoList] = useState([]);
  const [filteradName, setFilteradName] = useState("");
  const [filterUserId, setFilterUserId] = useState("");
  const [filterCreatedAt, setFilterCreatedAt] = useState("");
  const [filterDevice, setFilterDevice] = useState("");
  const [filterOs, setFilterOs] = useState("");
  const [filterAppVersion, setFilterAppVersion] = useState("");
  const [filterEventKbn, setFilterEventKbn] = useState("");
  const [filterDisplayedAt, setFilterDisplayedAt] = useState("");

  const [filterBeforeYesTodayAutoAdCnt, setFilterBeforeYesTodayAutoAdCnt] =
    useState("");
  const [filterBeforeYesTodayClickAdCnt, setFilterBeforeYesTodayClickAdCnt] =
    useState("");
  const [
    filterBeforeYesTodayHomeInitAdCnt,
    setFilterBeforeYesTodayHomeInitAdCnt,
  ] = useState("");
  const [filterYesTodayAutoAdCnt, setFilterYesTodayAutoAdCnt] = useState("");
  const [filterYesTodayClickAdCnt, setFilterYesTodayClickAdCnt] = useState("");
  const [filterYesTodayHomeInitAdCnt, setFilterYesTodayHomeInitAdCnt] =
    useState("");
  const [filterTodayAutoAdCnt, setFilterTodayAutoAdCnt] = useState("");
  const [filterTodayClickAdCnt, setFilterTodayClickAdCnt] = useState("");
  const [filterTodayHomeInitAdCnt, setFilterTodayHomeInitAdCnt] = useState("");
  const [filterAllTodayAdCnt, setFilterAllTodayAdCnt] = useState("");

  //const [searchMode, setSearchMode] = useState<'and' | 'or'>('and');
  const [searchMode, setSearchMode] = useState("and");
  const [searchSumMode, setSearchSumMode] = useState("and");
  const [sortColumn, setSortColumn] = useState("");
  //const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [sortDirection, setSortDirection] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
    }
    const getInfos = async () => {
      try {
        const res1 = await getADDisplayInfoSUMList();
        if (res1.code === 200 && res1.data.length > 0) {
          const infoSUM = res1.data.map((item) => ({
            ad_name: item.ad_name,
            beforeYesToday_auto_ad_cnt: item.beforeYesToday_auto_ad_cnt,
            beforeYesToday_click_ad_cnt: item.beforeYesToday_click_ad_cnt,
            beforeYesToday_home_init_ad_cnt:
              item.beforeYesToday_home_init_ad_cnt,

            yesToday_auto_ad_cnt: item.yesToday_auto_ad_cnt,
            yesToday_click_ad_cnt: item.yesToday_click_ad_cnt,
            yesToday_home_init_ad_cnt: item.yesToday_home_init_ad_cnt,

            today_auto_ad_cnt: item.today_auto_ad_cnt,
            today_click_ad_cnt: item.today_click_ad_cnt,
            today_home_init_ad_cnt: item.today_home_init_ad_cnt,

            all_ad_cnt:
              item.beforeYesToday_auto_ad_cnt +
              item.beforeYesToday_click_ad_cnt +
              item.beforeYesToday_home_init_ad_cnt +
              item.yesToday_auto_ad_cnt +
              item.yesToday_click_ad_cnt +
              item.yesToday_home_init_ad_cnt +
              item.today_auto_ad_cnt +
              item.today_click_ad_cnt +
              item.today_home_init_ad_cnt,
          }));
          setSUMInfoList(infoSUM);
        }

        const res = await getADDisplayInfoList();
        if (res.code === 200 && res.data.length > 0) {
          const adInfo = res.data.map((item) => ({
            ad_name: item.ad_name,
            user_id: item.user_id,
            device: item.device,
            os: item.os,
            app_version: item.app_version,
            displayed_at: item.displayed_at,
            event_kbn:
              item.event_kbn === "0"
                ? "自動"
                : item.event_kbn === "1"
                ? "ク"
                : "ホーム",
            created_at: item.created_at,
          }));
          setInfoList(adInfo);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getInfos();
  }, [navigate]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const adSumFilteredList = infoSUMList.filter((item) => {
    const conds = [
      (item.ad_name?.toString() ?? "").includes(filteradName),
      (item.beforeYesToday_auto_ad_cnt?.toString() ?? "").includes(
        filterBeforeYesTodayAutoAdCnt
      ),
      (item.beforeYesToday_click_ad_cnt?.toString() ?? "").includes(
        filterBeforeYesTodayClickAdCnt
      ),
      (item.beforeYesToday_home_init_ad_cnt?.toString() ?? "").includes(
        filterBeforeYesTodayHomeInitAdCnt
      ),

      (item.yesToday_auto_ad_cnt?.toString() ?? "").includes(
        filterYesTodayAutoAdCnt
      ),
      (item.yesToday_click_ad_cnt?.toString() ?? "").includes(
        filterYesTodayClickAdCnt
      ),
      (item.yesToday_home_init_ad_cnt?.toString() ?? "").includes(
        filterYesTodayHomeInitAdCnt
      ),

      (item.today_auto_ad_cnt?.toString() ?? "").includes(filterTodayAutoAdCnt),
      (item.today_click_ad_cnt?.toString() ?? "").includes(
        filterTodayClickAdCnt
      ),
      (item.today_home_init_ad_cnt?.toString() ?? "").includes(
        filterTodayHomeInitAdCnt
      ),

      (item.all_ad_cnt?.toString() ?? "").includes(filterAllTodayAdCnt),
    ];
    return searchSumMode === "and" ? conds.every(Boolean) : conds.some(Boolean);
  });

  const adSumSortedList = sortColumn
    ? [...adSumFilteredList].sort((a, b) => {
        const valA = a[sortColumn];
        const valB = b[sortColumn];
        if (valA == null || valB == null) return 0;

        if (typeof valA === "number" && typeof valB === "number") {
          return sortDirection === "asc" ? valA - valB : valB - valA;
        }

        return sortDirection === "asc"
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      })
    : adSumFilteredList;

  const filteredList = infoList.filter((item) => {
    const conds = [
      (item.ad_name?.toString() ?? "").includes(filteradName),
      (item.user_id?.toString() ?? "").includes(filterUserId),
      (item.device?.toString() ?? "").includes(filterDevice),
      (item.os?.toString() ?? "").includes(filterOs),
      (item.app_version?.toString() ?? "").includes(filterAppVersion),
      (item.displayed_at?.toString() ?? "").includes(filterDisplayedAt),
      (item.event_kbn?.toString() ?? "").includes(filterEventKbn),
      (item.created_at?.toString() ?? "").includes(filterCreatedAt),
    ];
    return searchMode === "and" ? conds.every(Boolean) : conds.some(Boolean);
  });

  const sortedList = sortColumn
    ? [...filteredList].sort((a, b) => {
        const valA = a[sortColumn];
        const valB = b[sortColumn];
        if (valA == null || valB == null) return 0;

        if (typeof valA === "number" && typeof valB === "number") {
          return sortDirection === "asc" ? valA - valB : valB - valA;
        }

        return sortDirection === "asc"
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      })
    : filteredList;

  const totalPages = Math.ceil(sortedList.length / pageSize);
  const paginatedList = sortedList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredList.length]);

  const handleClear = () => {
    setFilteradName("");
    setFilterUserId("");
    setFilterCreatedAt("");
    setFilterDevice("");
    setFilterOs("");
    setFilterAppVersion("");
    setFilterDisplayedAt("");
    setFilterEventKbn("");
    setFilterBeforeYesTodayAutoAdCnt("");
    setFilterBeforeYesTodayClickAdCnt("");
    setFilterBeforeYesTodayHomeInitAdCnt("");
    setFilterYesTodayAutoAdCnt("");
    setFilterYesTodayHomeInitAdCnt("");
    setFilterYesTodayClickAdCnt("");
    setFilterTodayAutoAdCnt("");
    setFilterTodayClickAdCnt("");
    setFilterTodayHomeInitAdCnt("");
    setFilterAllTodayAdCnt("");
  };

  const exportToExcel = () => {
    const data = sortedList.map((item) => ({
      広告対象: item.ad_name,
      ユーザー: item.user_id,
      広告対象期間: item.displayed_at,
      アクセス時間: item.created_at,
      端末: item.device,
      イベント: item.event_kbn,
      OS: item.os,
      アプリ: item.app_version,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ADDisplayInfo");
    XLSX.writeFile(workbook, "ADDisplayInfoList.xlsx");
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return "";
    return sortDirection === "asc" ? " ▲" : " ▼";
  };
  const exportToExcelFromSum = () => {
    const data = adSumSortedList.map((item) => ({
      広告対象: item.ad_name,
      "自動ロード数(昨日)": item.yesToday_auto_ad_cnt,
      "自動ロード数(今日)": item.today_auto_ad_cnt,
      "個別クリック数(昨日)": item.yesToday_click_ad_cnt,
      "個別クリック数(今日)": item.today_click_ad_cnt,
      "ホーム画面起動数(昨日)": item.yesToday_home_init_ad_cnt,
      "ホーム画面起動数(今日)": item.today_home_init_ad_cnt,
      全体合計: item.all_ad_cnt,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ADDisplayInfo_SUM");
    XLSX.writeFile(workbook, "ADDisplayInfo_SUM.xlsx");
  };

  return (
    <MainLayout>
      <div
        style={{ marginBottom: "10px", textAlign: "left", color: "#008000" }}
      >
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
          広告-アクセス状況
        </span>
      </div>
      {/* フィルターエリア */}
      <div
        style={{
          marginBottom: "10px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px" }}>絞り込み条件</span>
      </div>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="広告対象"
          value={filteradName}
          onChange={(e) => setFilteradName(e.target.value)}
        />
        <input
          type="text"
          placeholder="自動ロード数(昨日)"
          value={filterBeforeYesTodayAutoAdCnt}
          onChange={(e) => setFilterBeforeYesTodayAutoAdCnt(e.target.value)}
        />
        <input
          type="text"
          placeholder="自動ロード数(今日)"
          value={filterTodayAutoAdCnt}
          onChange={(e) => setFilterTodayAutoAdCnt(e.target.value)}
        />
        <input
          type="text"
          placeholder="個別クリック数(昨日)"
          value={filterYesTodayClickAdCnt}
          onChange={(e) => setFilterYesTodayClickAdCnt(e.target.value)}
        />
        <input
          type="text"
          placeholder="個別クリック数(今日)"
          value={filterTodayClickAdCnt}
          onChange={(e) => setFilterTodayClickAdCnt(e.target.value)}
        />
        <input
          type="text"
          placeholder="ホーム画面起動数(昨日)"
          value={filterYesTodayHomeInitAdCnt}
          onChange={(e) => setFilterYesTodayHomeInitAdCnt(e.target.value)}
        />
        <input
          type="text"
          placeholder="ホーム画面起動数(今日)"
          value={filterTodayHomeInitAdCnt}
          onChange={(e) => setFilterTodayHomeInitAdCnt(e.target.value)}
        />
        <button onClick={handleClear}>クリア</button>
        <button onClick={exportToExcelFromSum}>Excel出力</button>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>
          <input
            type="radio"
            value="and"
            checked={searchSumMode === "and"}
            onChange={() => setSearchSumMode("and")}
          />
          AND検索
        </label>
        <label style={{ marginLeft: "10px" }}>
          <input
            type="radio"
            value="or"
            checked={searchSumMode === "or"}
            onChange={() => setSearchSumMode("or")}
          />
          OR検索
        </label>
      </div>

      <div
        style={{
          marginBottom: "5px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px" }}>
          📊 全データ：{infoSUMList.length} 件 ／ フィルター結果：
          {adSumFilteredList.length} 件
        </span>
      </div>
      <TableSum>
        <thead>
          {/* グループヘッダー */}
          <tr>
            <TableHeader rowSpan={2} onClick={() => handleSort("ad_name")}>
              広告対象{renderSortIcon("ad_name")}
            </TableHeader>
            <TableHeader colSpan={2}>自動ロード数</TableHeader>
            <TableHeader colSpan={2}>個別クリック数</TableHeader>
            <TableHeader colSpan={2}>ホーム画面起動数</TableHeader>
            <TableHeader rowSpan={2} onClick={() => handleSort("all_ad_cnt")}>
              全体合計(～現在){renderSortIcon("all_ad_cnt")}
            </TableHeader>
          </tr>

          {/* 昨日・今日ヘッダー */}
          <tr>
            <TableHeader onClick={() => handleSort("yesToday_auto_ad_cnt")}>
              昨日{renderSortIcon("yesToday_auto_ad_cnt")}
            </TableHeader>
            <TableHeader onClick={() => handleSort("today_auto_ad_cnt")}>
              今日{renderSortIcon("today_auto_ad_cnt")}
            </TableHeader>

            <TableHeader onClick={() => handleSort("yesToday_click_ad_cnt")}>
              昨日{renderSortIcon("yesToday_click_ad_cnt")}
            </TableHeader>
            <TableHeader onClick={() => handleSort("today_click_ad_cnt")}>
              今日{renderSortIcon("today_click_ad_cnt")}
            </TableHeader>

            <TableHeader
              onClick={() => handleSort("yesToday_home_init_ad_cnt")}
            >
              昨日{renderSortIcon("yesToday_home_init_ad_cnt")}
            </TableHeader>
            <TableHeader onClick={() => handleSort("today_home_init_ad_cnt")}>
              今日{renderSortIcon("today_home_init_ad_cnt")}
            </TableHeader>
          </tr>
        </thead>
        <tbody>
          {adSumSortedList.map((item, index) => (
            <TableRow key={index}>
              <TitleCell>{item.ad_name}</TitleCell>
              <TitleCell>
                {item.yesToday_auto_ad_cnt.toLocaleString()}
              </TitleCell>
              <TitleCell>{item.today_auto_ad_cnt.toLocaleString()}</TitleCell>
              <TitleCell>
                {item.yesToday_click_ad_cnt.toLocaleString()}
              </TitleCell>
              <TitleCell>{item.today_click_ad_cnt.toLocaleString()}</TitleCell>
              <TitleCell>
                {item.yesToday_home_init_ad_cnt.toLocaleString()}
              </TitleCell>
              <TitleCell>
                {item.today_home_init_ad_cnt.toLocaleString()}
              </TitleCell>
              <TitleCell>{item.all_ad_cnt.toLocaleString()}</TitleCell>
            </TableRow>
          ))}
        </tbody>
      </TableSum>

      {/* フィルターエリア */}
      <div
        style={{
          marginBottom: "10px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px" }}>
          絞り込み条件(※今日の対象データ)
        </span>
      </div>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <input
          type="text"
          placeholder="広告対象"
          value={filteradName}
          onChange={(e) => setFilteradName(e.target.value)}
        />
        <input
          type="text"
          placeholder="ユーザー"
          value={filterUserId}
          onChange={(e) => setFilterUserId(e.target.value)}
        />
        <input
          type="text"
          placeholder="広告対象期間"
          value={filterDisplayedAt}
          onChange={(e) => setFilterDisplayedAt(e.target.value)}
        />
        <input
          type="text"
          placeholder="アクセス日"
          value={filterCreatedAt}
          onChange={(e) => setFilterCreatedAt(e.target.value)}
        />
        <input
          type="text"
          placeholder="端末"
          value={filterDevice}
          onChange={(e) => setFilterDevice(e.target.value)}
        />
        <input
          type="text"
          placeholder="OS"
          value={filterOs}
          onChange={(e) => setFilterOs(e.target.value)}
        />
        <input
          type="text"
          placeholder="イベント"
          value={filterEventKbn}
          onChange={(e) => setFilterEventKbn(e.target.value)}
        />
        <input
          type="text"
          placeholder="アプリ"
          value={filterAppVersion}
          onChange={(e) => setFilterAppVersion(e.target.value)}
        />
        <button onClick={handleClear}>クリア</button>
        <button onClick={exportToExcel}>Excel出力</button>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>
          <input
            type="radio"
            value="and"
            checked={searchMode === "and"}
            onChange={() => setSearchMode("and")}
          />
          AND検索
        </label>
        <label style={{ marginLeft: "10px" }}>
          <input
            type="radio"
            value="or"
            checked={searchMode === "or"}
            onChange={() => setSearchMode("or")}
          />
          OR検索
        </label>
      </div>

      <div
        style={{
          marginBottom: "5px",
          textAlign: "left",
          color: "#666",
          fontStyle: "italic",
        }}
      >
        <span style={{ fontSize: "13px" }}>
          📊 全データ(今日分のみ)：{infoList.length} 件 ／ フィルター結果：
          {filteredList.length} 件
        </span>
      </div>
      {loading ? (
        <div style={{ padding: "20px" }}>読み込み中...</div>
      ) : (
        <>
        <div style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             gap: "10px",
             padding: "20px",
             flexWrap: "wrap"
           }}>
             <button
               onClick={() => setCurrentPage(1)}
               disabled={currentPage === 1}
             >最初</button>
             <button
               onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
               disabled={currentPage === 1}
             >前へ</button>
             <span>
               {currentPage} / {totalPages} ページ
               （全{sortedList.length}件中 {paginatedList.length}件表示）
             </span>
             <button
               onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
               disabled={currentPage === totalPages}
             >次へ</button>
             <button
               onClick={() => setCurrentPage(totalPages)}
               disabled={currentPage === totalPages}
             >最後</button>
             <select
               value={pageSize}
               onChange={(e) => {
                 setPageSize(Number(e.target.value));
                 setCurrentPage(1);
               }}
             >
               <option value={50}>50件</option>
               <option value={100}>100件</option>
               <option value={200}>200件</option>
               <option value={500}>500件</option>
             </select>
          </div>
          <Table>
            <thead>
              <tr>
                <TableHeader onClick={() => handleSort("ad_name")}>
                  広告対象{renderSortIcon("ad_name")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("user_id")}>
                  ユーザー{renderSortIcon("user_id")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("displayed_at")}>
                  広告対象期間{renderSortIcon("displayed_at")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("created_at")}>
                  アクセス時間{renderSortIcon("created_at")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("device")}>
                  端末{renderSortIcon("device")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("os")}>
                  OS{renderSortIcon("os")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("event_kbn")}>
                  イベント{renderSortIcon("event_kbn")}
                </TableHeader>
                <TableHeader onClick={() => handleSort("app_version")}>
                  アプリ{renderSortIcon("app_version")}
                </TableHeader>
              </tr>
            </thead>
             <tbody>
               {paginatedList.map((item, index) => (
                 <TableRow key={(currentPage - 1) * pageSize + index}>
                   <TitleCell>{item.ad_name}</TitleCell>
                   <TitleCell>{item.user_id}</TitleCell>
                   <TitleCell>{item.displayed_at}</TitleCell>
                   <TitleCell>{item.created_at}</TitleCell>
                   <TitleCell>{item.device}</TitleCell>
                   <TitleCell>{item.os}</TitleCell>
                   <TitleCell>{item.event_kbn}</TitleCell>
                   <TitleCell>{item.app_version}</TitleCell>
                 </TableRow>
               ))}
             </tbody>
           </Table>
           <div style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             gap: "10px",
             padding: "20px",
             flexWrap: "wrap"
           }}>
             <button
               onClick={() => setCurrentPage(1)}
               disabled={currentPage === 1}
             >最初</button>
             <button
               onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
               disabled={currentPage === 1}
             >前へ</button>
             <span>
               {currentPage} / {totalPages} ページ
               （全{sortedList.length}件中 {paginatedList.length}件表示）
             </span>
             <button
               onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
               disabled={currentPage === totalPages}
             >次へ</button>
             <button
               onClick={() => setCurrentPage(totalPages)}
               disabled={currentPage === totalPages}
             >最後</button>
             <select
               value={pageSize}
               onChange={(e) => {
                 setPageSize(Number(e.target.value));
                 setCurrentPage(1);
               }}
             >
               <option value={50}>50件</option>
               <option value={100}>100件</option>
               <option value={200}>200件</option>
               <option value={500}>500件</option>
             </select>
            </div>
         </>
       )}
    </MainLayout>
  );
}

export default ADDisplayInfo;
